export const appHead = {"link":[{"rel":"icon","type":"image/png","sizes":"128x128","href":"/icons/favicon-128x128.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/icons/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/icons/favicon-16x16.png"},{"rel":"icon","type":"image/png","href":"/favicon.ico"},{"rel":"apple-touch-startup-image","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3)","href":"/icons/apple-launch-1284x2778.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3)","href":"/icons/apple-launch-1170x2532.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)","href":"/icons/apple-launch-828x1792.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)","href":"/icons/apple-launch-1125x2436.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)","href":"/icons/apple-launch-1242x2688.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)","href":"/icons/apple-launch-750x1334.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3)","href":"/icons/apple-launch-1242x2208.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2)","href":"/icons/apple-launch-1620x2160.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)","href":"/icons/apple-launch-1536x2048.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)","href":"/icons/apple-launch-1668x2224.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)","href":"icons/apple-launch-1668x2388.png"},{"rel":"apple-touch-startup-image","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)","href":"icons/apple-launch-2048x2732.png"},{"rel":"alternate","type":"application/rss+xml","title":"KYGUNCO Products On Sale RSS 2.0 Feed","href":"/feeds/products/sale/rss"},{"rel":"alternate","type":"application/atom+xml","title":"KYGUNCO Products On Sale Atom 1.0 Feed","href":"/feeds/products/sale/atom"},{"rel":"alternate","type":"application/json","title":"KYGUNCO Products On Sale JSON 1.0 Feed","href":"/feeds/products/sale/json"},{"rel":"alternate","type":"application/rss+xml","title":"KYGUNCO Blog RSS 2.0 Feed","href":"/feeds/blog/rss"},{"rel":"alternate","type":"application/atom+xml","title":"KYGUNCO Blog Atom 1.0 Feed","href":"/feeds/blog/atom"},{"rel":"alternate","type":"application/json","title":"KYGUNCO Blog JSON 1.0 Feed","href":"/feeds/blog/json"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"name":"apple-mobile-web-app-title","content":"KYGUNCO"},{"name":"application-name","content":"KYGUNCO"},{"name":"author","content":"KYGUNCO"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","templateParams":{"separator":"|"},"htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false